export { routingMiddleware, default as routingReducer } from "./routingReducer";
